<button
  type="button"
  class="select__trigger"
  [disabled]="disabled"
  (click)="onClick()"
  role="combobox"
  aria-haspopup="listbox"
  [attr.aria-expanded]="open"
>
  <div class="select__value">
    <ng-content select="[frodo-select-value]"></ng-content>
  </div>

  <div class="select__chevron-wrap" aria-hidden="true">
    <span class="select__chevron"></span>
  </div>
</button>

<div #panel class="select__panel" role="listbox" [class.is-open]="open">
  <ng-content select="frodo-select-option"></ng-content>
</div>
